import { render, staticRenderFns } from "./bloodPressureMonitor.vue?vue&type=template&id=9c34f84c"
import script from "./bloodPressureMonitor.vue?vue&type=script&lang=js"
export * from "./bloodPressureMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports